(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["downloads-list"] && !Shopify.designMode) return;
  try {
    
  class DownloadsListFetchItem extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-fd-button]');
      this.badge = this.querySelector('[data-fd-badge]');
      this.versionEl = this.closest('.downloads-list__item')?.querySelector(this.dataset.versionTarget);
      this.fetchUpdateInfo();
    }

    fetchUpdateInfo() {
      const productId = this.dataset.productId;
      const url = `${this.dataset.apiUrl}?product_id=${encodeURIComponent(productId)}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then((data) => this.render(data))
        .catch(() => this.renderUnavailable());
    }

    bestEntry(results) {
      return results.stable || results.latest || results.previous || null;
    }

    isSafeUrl(value) {
      if (!value) return false;
      try {
        const parsed = new URL(value, window.location.href);
        return parsed.protocol === 'https:' || parsed.protocol === 'http:';
      } catch (error) {
        return false;
      }
    }

    render(data) {
      const results = data && data.results;
      const entry = results && this.bestEntry(results);

      if (!entry || data.error || !this.isSafeUrl(entry.file_url)) {
        this.renderUnavailable();
        return;
      }

      const link = this.button.tagName === 'A' ? this.button : document.createElement('a');
      link.className = 'downloads-list__item-button button button--secondary';
      link.href = entry.file_url;
      link.setAttribute('download', '');
      link.setAttribute('data-fd-button', '');
      link.textContent = this.dataset.labelDownload;
      if (link !== this.button) this.button.replaceWith(link);
      this.button = link;
      if (this.badge) this.badge.hidden = true;

      if (entry.version && this.versionEl) {
        this.versionEl.textContent = `${this.dataset.versionPrefix}${entry.version}`;
        this.versionEl.hidden = false;
      }
    }

    renderUnavailable() {
      if (!this.button) return;
      this.button.textContent = this.dataset.labelDownload;
      if (this.badge) this.badge.hidden = this.button.tagName === 'A';
    }
  }

  customElements.define('downloads-list-fetch-item', DownloadsListFetchItem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zen-dsp-features"] && !Shopify.designMode) return;
  try {
    
(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.zen-dsp-features__carousel').forEach((slider) => {
    if (prefersReducedMotion || !slider.nextButton || !slider.slider) return;

    let autoplay;

    const start = () => {
      autoplay = setInterval(() => {
        if (slider.nextButton.hasAttribute('disabled')) {
          slider.setSlidePosition(0);
        } else {
          slider.nextButton.click();
        }
      }, 4000);
    };

    const stop = () => clearInterval(autoplay);

    start();
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
